<template>
  <vs-popup fullscreen class="rm-order-po-pdf-popup"
            id="rm-order-po-pdf-pop-up"
            title="SAMPLE DELIVERY NOTE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex">
            <div class="flex">
              <vs-button @click="onClickPrint()" color="warning" type="border" >Print & Download</vs-button>
              <vs-button @click.stop="generateReportPromtActive()"  class="ml-2 hidden" color="dark" type="border" >
                Send to Customer
              </vs-button>
            </div>
          </div>
        </div>
      </div>

      <body id="myelement">
      <div id="full-wrap">


        <main class="clearfix">

          <div id="user" class="clearfix">

            <div id="user-top">

              <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                <tbody>
                <tr>
                  <td class="head align-left">
                    <img id="logo"
                         src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                         alt="Logo" width="300" height="150" />
                  </td>


                </tr>


                <tr>
                  <td>
                    <table id="main-tbl">
                      <thead class="">
                      <tr>
                        <td colspan="2" class="head">
                          <h4 style="color: black" class="m-0"><b>SAMPLE DELIVERY NOTE</b></h4>
                        </td>
                      </tr>
                      </thead>

                      <tbody>

                      <tr>

                        <td class="toptd bd-b-0 bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">SHIPPER/EXPORTER</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda" width="55%">
                                <div>
                                  <p class="sml">
                                    {{ company_address.company_name }}<br>
                                    {{ company_address.line1 }}<br>
                                    {{ company_address.line2 }}<br>
                                    {{ company_address.town_state }}<br>
                                    {{ company_address.post_code }}<br>
                                    {{ company_address.country }}</p>
                                </div>
                              </td>
                              <td class="bodytdb">
                                <div>
                                  <p class="sml">Tel. {{ sample_order_data.shipper.tel || '' }}<br>
                                    Email: {{ sample_order_data.shipper.email || '' }}<br>
                                    VAT Reg No: {{ sample_order_data.shipper.vat_reg || '' }}<br>
                                    Company No: {{ sample_order_data.shipper.company_no || '' }}<br>
                                    EORI for NL: {{ sample_order_data.shipper.eori_ni || '' }}<br>
                                    EORI for EU: {{ sample_order_data.shipper.eori_eu || '' }}</p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td width="55%">
                                <div>
                                  <p class="sml">SAMPLE ORDER CODE:</p>
                                  <p class="sml"><b>{{ sample_order_data.sample_order_code || '' }}</b></p>
                                </div>
                              </td>
                              <td width="45%">
                                <div>
                                  <p class="sml">DISPATCH DATE:</p>
                                  <p class="sml">
                                    <b>
                                      {{  sample_order_data.shipping_details.length > 0 ? sample_order_data.shipping_details[0].booking_date : 'N/A'}}
                                    </b>
                                  </p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td width="55%">
                                <div>
                                  <p class="sml">EXPECTED DATE:</p>
                                  <p class="sml">
                                    <b>
                                      {{  sample_order_data.shipping_details.length > 0 ? sample_order_data.shipping_details[0].expected_date : 'N/A'}}
                                    </b>
                                  </p>
                                </div>
                              </td>
                              <td width="55%">
                                <div>
                                  <p class="sml">COURIER NAME:</p>
                                  <p class="sml">
                                    <b>
                                      {{  sample_order_data.shipping_details.length > 0 ? sample_order_data.shipping_details[0].name : 'N/A'}}
                                    </b>
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td class="toptd bd-b-0 bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">CONSIGNEE/RECEIVER</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda" width="55%">
                                <div>
                                  <p class="sml">
                                    <span style="font-weight: normal">{{ sample_order_data.name }}</span> <br v-if="sample_order_data.name">
                                    <span style="font-weight: normal">{{ sample_order_data.line1 }}</span> <br v-if="sample_order_data.line1">
                                    <span style="font-weight: normal">{{ sample_order_data.line2 }}</span> <br v-if="sample_order_data.line2">
                                    <span style="font-weight: normal">{{ sample_order_data.line3 }}</span> <br v-if="sample_order_data.line3">
                                    <span style="font-weight: normal">{{ sample_order_data.town_state }}</span> <br v-if="sample_order_data.town_state">
                                    <span style="font-weight: normal">{{ sample_order_data.post_code }}</span> <br v-if="sample_order_data.post_code">
                                    <span style="font-weight: normal">{{ sample_order_data.country }}</span> <br v-if="sample_order_data.country">
                                  </p>
                                </div>
                              </td>
                              <td class="bodytdb">
                                <div>
                                  <p class="sml">
                                    VAT: {{ sample_order_data.consignee.vat || '' }}<br>
                                    EORI: {{ sample_order_data.consignee.eori || '' }}<br>
                                    TSS Reg No: {{ sample_order_data.consignee.tss_registration_number || '' }}<br>
                                    TEL: {{ sample_order_data.consignee.tel || '' }}<br>
                                    IMPORT LICENCE NO: {{ sample_order_data.consignee.import_licence_no || '' }}</p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td width="55%">
                                <div>
                                  <p class="sml">{{  sample_order_data.customer ? "CUSTOMER ACCOUNT NUMBER:" : "CUSTOMER LEAD CODE:"  }}</p>
                                  <p class="sml"><b>{{ sample_order_data.customer ? sample_order_data.customer.account_number : sample_order_data.customer_lead.code }}</b></p><br>
                                </div>
                              </td>
                              <td width="45%">
                                <div>
                                  <p class="sml">BOOKING REF NUMBER:</p>
                                  <p class="sml">
                                    <b>
                                      {{  sample_order_data.shipping_details.length > 0 ? sample_order_data.shipping_details[0].reference_no : 'N/A'}}
                                    </b>
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td colspan="2" class="toptd">
                          <table id="content-tbl">
                            <thead>
                            <tr>
                              <th><b>Product Code</b></th>
                              <th><b>Product Name</b></th>
                              <th><b>Quantity (GRAM)</b></th>
                              <th><b>Price Per Unit ({{ account_currency }}/KG)</b></th>
                              <th><b>Net Value ({{ account_currency }})</b></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in sample_order_data.formulation_items" :key="index">
                              <td>{{ item.formulation_code }}</td>
                              <td>{{ item.name }}</td>
                              <td>{{ Number(item.quantity) }}</td>
                              <td>{{ Number(item.price) | format_price(fx_value) }}</td>
                              <td>{{ calculateNetValue(item) }}</td>

                            </tr>
                            <tr>
                              <td  v-bind:style="styleObject" class="htd" rowspan="1">&nbsp;</td>
                              <td  v-bind:style="styleObject" class="htd" rowspan="1">&nbsp;</td>
                              <td  v-bind:style="styleObject" class="htd" rowspan="1">&nbsp;</td>
                              <td  v-bind:style="styleObject" class="htd" rowspan="1">&nbsp;</td>
                              <td  v-bind:style="styleObject" class="htd" rowspan="1">&nbsp;</td>
                            </tr>

                            </tbody>
                          </table>
                        </td>

                      </tr>

                      <tr>
                        <td colspan="2" class="toptd">

                          <table class="no-bd-tbl">
                            <thead>

                            <tr>
                              <td colspan="4">
                                <b>Notes:</b> <br>
                                <b>Special INSTRUCTIONS FOR DELIVERY: </b>{{ sample_order_data.delivery_instruction || 'N/A' }}
                              </td>
                            </tr>

                            <tr>
                              <td colspan="2">
                                <table>
                                  <tr>
                                  <td>
                                    <p style="font-weight: bolder; padding-top: 50px">
                                      Transport by (company name): ...............................<br>
                                      <span class="pb-2">Driver's signature</span><br><br>
                                      Print Name ................................................................<br>
                                      Date/Time of pick up ................................................
                                    </p>
                                  </td>
                                  <td>
                                    <p style="font-weight: bolder; padding-top: 50px">
                                      <span class="mb-2">Consignee signature</span><br><br>
                                      Print Name .........................................................................<br>
                                      Date/Time received .................................................................
                                    </p>
                                  </td>
                                  </tr>
                                </table>
                              </td>
                              <td>
                                <img v-if="!is_customer_uk" style="padding-top: 25px" width="200" src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/s_jones_signature.png" alt="">
                              </td>
                              <td>
                                <img v-if="!is_customer_uk" style="padding-top: 25px" width="200" src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/its_stamp.bmp" alt="">
                              </td>
                            </tr>
<!--                            <tr>-->
<!--                              <td colspan="4">-->
<!--                                <p class="align-center">ITS reserves the right to-->
<!--                                  charge-->
<!--                                  interest on late payments<br>-->
<!--                                  ITS terms and conditions of sale apply.</p>-->
<!--                              </td>-->
<!--                            </tr>-->
                            </thead>
                          </table>
                        </td>

                      </tr>


                      </tbody>
                    </table>
                  </td>
                </tr>









                </tbody>
              </table>



            </div>

          </div>

        </main>



      </div>
      </body>
    </vx-card>
    <vs-prompt
      @cancel="customer_email=''"
      @accept="generateReport"
      @close="activePrompt = false"
      :title="'Select customer user email to send'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Select user email</span>
        <v-select
          :clearable="true" name="customerId" placeholder=""
          v-model="customer_email"
          label="email"
          :options="customer_list"
          :reduce="option => option.email"
          :dir="$vs.rtl ? 'rtl' : 'ltr'">
          <template v-slot:option="option">
              <span>{{option.email}} ( {{option.job_title || 'N/A'}} ) </span>
          </template>
          </v-select>
      </div>
    </vs-prompt>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations';
  const CustomerRepository = RepositoryFactory.get('customer')
  const CourierRepository = RepositoryFactory.get('courier')
  const DropDownRepository = RepositoryFactory.get('drop_down')
  const SettingsRepository = RepositoryFactory.get('settings');
  const CompanyAddressRepository = RepositoryFactory.get('company_address');

  import { Printd } from 'printd'
  import {mapActions, mapGetters} from "vuex";

  function initialState() {
    return {
      open: false,
      id: '',
      data: {},
      customer_email: "",
      activePrompt: false,
      sample_order_data: {
        shipping_details: [],
        customer: {
          account_number: ''
        },
        customer_lead: {
          code: ''
        },
        consignee: {
          tel: ''
        },
        shipper: {
          tel: ''
        }
      },
      company_address: {
          company_name: '',
          line1: '',
          line2: '',
          line3: '',
          town_state: '',
          post_code: '',
          country: '',
      },
      customer_list: [],
      invoice_data: {
        order_items: [],
        additional_costs: [],
        tel: '',
        shipper_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        },
        delivery_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        },
        customer_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        }
      },
      order_details: {
        supplier_address: {
          name: '',
          line1: '',
          line2: '',
          line3: '',
          town_state: '',
          post_code: '',
          country: ''
        },
        deliver_to: {
          name: '',
          line1: '',
          line2: '',
          line3: '',
          town_state: '',
          post_code: '',
          country: ''
        },
        invoice_to: {
          name: '',
          line1: '',
          line2: '',
          line3: '',
          town_state: '',
          post_code: '',
          country: ''
        },
        order_date: '',
        order_number: '',
        items: [],
        delivery_instruction: '',
        generated_on: ''
      },
      default_sample_item_price: null,
      account_currency: '',
      fx_value: ''
    }
  }

  export default {
    name: 'SampleDeliveryNotePdfPopUp',
    data () {
      return initialState()
    },
    computed: {
      ...mapGetters(["allSettings"]),
      styleObject: function () {
        const total_item_height = this.sample_order_data.formulation_items.length * 55
        const space_height = 500 - total_item_height
        return {
          height: `${space_height}px`
        }
      },
      is_customer_uk: function () {
        return ['Great Britain', 'Northern Ireland', 'United Kingdom'].includes(this.sample_order_data.country);
      }
    },
    methods:{
      async openPopup (order_details, account_currency, fx_value) {
        try {
          await Object.assign(this.$data, initialState())
          this.id = order_details.id
          this.sample_order_data = order_details
          this.account_currency = account_currency
          this.fx_value = fx_value
          await this.fetchSettings()
          this.open = true
        } catch (error) {

        }
      },
      async fetchSettings() {
        const settings = (await SettingsRepository.getTheItem('default_sample_item_price')).data.data
        this.default_sample_item_price = settings.default_sample_item_price

        const { data: addresses } = (await CompanyAddressRepository.getCompanyAddresses('filter[is_default]=1')).data
        const defaultAddress = addresses[0]
        if (defaultAddress) {
          this.company_address.line1 = defaultAddress.line1 || ''
          this.company_address.line2 = defaultAddress.line2 || ''
          this.company_address.line3 = defaultAddress.line3 || ''
          this.company_address.town_state = defaultAddress.town_state || ''
          this.company_address.post_code = defaultAddress.post_code || ''
          this.company_address.country = defaultAddress.country || ''
          this.company_address.company_name = defaultAddress.name || ''
        }
      },
      calculateNetValue(item) {
        const quantityInKg = Number(item.quantity) / 1000;
        const unitPrice = Number(this.$options.filters.format_price(item.price, this.fx_value));
        return (quantityInKg * unitPrice).toFixed(2);
      },
      async testPrint() {
        const d = new Printd()
        d.printURL('/pages/product-orders/167', ({ launchPrint }) => {
          // fire printing!
          launchPrint()
        })
      },
      onClickPrint() {
         const d = new Printd()
        const styles = `
          html,
body {
  -webkit-print-color-adjust: exact !important;
}
@media print {
  body {
    zoom: 75%;
  }
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table td:nth-child(2) {
  word-break: break-all;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 2em auto 2em auto;
}

div#user-top table {
  margin: 0 auto 0 auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 20px;
  font-size: 14px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

table#in-tbl thead td.headtd {
  border: 2px solid #000;
  border-bottom-width: 0px;

}

table#in-tbl tbody td.bodytda {
  border: 2px solid #000;
  border-top-width: 0px;
  border-right-width: 0px;

}

table#in-tbl tbody td.bodytdb {
  border: 2px solid #000;
  border-top-width: 0px;
  border-left-width: 0px;

}

table#in-tbl tbody td.bodytd {
  border: 2px solid #000;
  border-top-width: 0px;


}

table#main-tbl thead td {
  border: 3px solid #000;
  border-bottom-width: 2px;

}

table#main-tbl tbody td.toptd {
  border: 3px solid #000;
  border-top-width: 0px;
  padding: 5px;
  width: 50%;
}

table#main-tbl tbody td.toptd table#in-tbl {
  min-height: 15em;
}

table#content-tbl th,
table#content-tbl td {
  border: 2px solid #000;
  font-size: 13px !important;
  text-align: center;
}


/* table#content-tbl td[rowspan="1"] {
    height: 300px;
} */


td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;

}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-center {
  text-align: center !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

.p-0 {
  padding: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.bd-b-0 {
  border-bottom-width: 0px !important;
}

.bd-r-0 {
  border-right-width: 0px !important;
}

.bd-l-0 {
  border-left-width: 0px !important;
}
        `
        d.print(document.getElementById('myelement'), [styles])
      },
      totalCalculator() {
        let total = 0;
        this.order_details.items.forEach((m) => {
          if (!!m.price) {
            total = total + Number(m.value)
          }
        })
        return total.toFixed(2)
      },
      async generateReportPromtActive() {
        try {
          const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.invoice_data.customer_id)).data
          this.customer_list = data
        } catch (e) {

        }
        this.open = false
        this.activePrompt = true
      },
      async generateReport() {
        this.open = true
        this.activePrompt = false
        this.$vs.loading()
        try {
          await CourierRepository.sendShipmentDocument(this.id, { user_email: this.customer_email})
          this.open = false
          this.showSuccessMessage('Delivery note sent successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }

        this.$vs.loading.close()
      },
    },
    components: {
      'v-select': vSelect
    },
    mixins: [SuccessMessage, ErrorMessages, Calculations],
  }
</script>

<style scoped>
html,
body {
  -webkit-print-color-adjust: exact !important;
}
/*@media print {*/
/*  body {*/
/*    zoom: 50%;*/
/*  }*/
/*}*/

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table td:nth-child(2) {
  word-break: break-all;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 2em auto 2em auto;
}

div#user-top table {
  margin: 0 auto 0 auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 20px;
  font-size: 14px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

table#in-tbl thead td.headtd {
  border: 2px solid #000;
  border-bottom-width: 0px;

}

table#in-tbl tbody td.bodytda {
  border: 2px solid #000;
  border-top-width: 0px;
  border-right-width: 0px;

}

table#in-tbl tbody td.bodytdb {
  border: 2px solid #000;
  border-top-width: 0px;
  border-left-width: 0px;

}

table#in-tbl tbody td.bodytd {
  border: 2px solid #000;
  border-top-width: 0px;


}

table#main-tbl thead td {
  border: 3px solid #000;
  border-bottom-width: 2px;

}

table#main-tbl tbody td.toptd {
  border: 3px solid #000;
  border-top-width: 0px;
  padding: 5px;
  width: 50%;
}

table#main-tbl tbody td.toptd table#in-tbl {
  min-height: 15em;
}

table#content-tbl th,
table#content-tbl td {
  border: 2px solid #000;
  font-size: 13px !important;
  text-align: center;
}


/* table#content-tbl td[rowspan="1"] {
    height: 300px;
} */


table#content-tbl td.htd {
  height: 800px;
}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;

}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-center {
  text-align: center !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

.p-0 {
  padding: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.bd-b-0 {
  border-bottom-width: 0px !important;
}

.bd-r-0 {
  border-right-width: 0px !important;
}

.bd-l-0 {
  border-left-width: 0px !important;
}
</style>
